import {connect} from "react-redux";
import CompleteCarServiceActivity from "./Complete";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../../service/fileUpload/action";
import {viewActivity} from "../../../../service/Activity/action";
import {accountById} from "../../../../service/Valet/action";
import {getActivity, activitySave, isCheckout, getPendingActivity, markAttendance} from "../../../../service/CarService/action";
import {getSenior} from "../../../../service/Dealer/action";
import {errorLogs} from "../../../../service/FasttagToll/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    types:state.CarService.types,
    attendance:state.CarService.attendance,
    pendingActivity:state.CarService.pendingActivity,
    saveActivityResponse:state.CarService.saveActivityResponse,
    getActivityDetails:state.Activity.activityByIdDetails,
    isCheckoutDetails:state.CarService.isCheckout,
    senior: state.Dealer.senior,
    accountByIdDetails:state.Valet.accountById,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            getActivity,
            getSenior,
            markAttendance,
            getPendingActivity,
            activitySave,
            viewActivity,
            isCheckout,
            accountById,
            errorLogs
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(CompleteCarServiceActivity);
